export default function AssetDashboardRouteConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('assetdashboard', {
		url: '/asset/{equipmentId}',
		template: `<asset-dashboard></asset-dashboard>`,
		requiredFeatures: ['assets.asset-dashboard']
	});
}
